<div class="container">
  <div class="row no-gutters">
    <div class="col-12">

      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>lblEditService</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
          </a>
        </div>

      </div>


      <form [formGroup]="editServiceForm" (ngSubmit)="EditServiceDetail()">
        <div class="scrollbar">
          <div class="card-content">
            <div class="card-body p-0">

              <div *ngIf="ServiceInfo" class="w-100 px-0">
                <div class="form-row">
                  <div class="col-lg-6 col-xl-3 af-form-group">
                    <label for="serviceNo" translate>lblServiceNumber<strong class="mlt6 required"> * </strong> </label>
                    <div class="lbl-info">
                      <input formControlName="serviceNo" class="form-control mb-2" maxlength="39"
                        [value]="cpf.serviceNo.value?.toUpperCase()"
                        [ngClass]="{'is-invalid': cpf.serviceNo.invalid && cpf.serviceNo.touched}">
                      <div *ngIf="cpf.serviceNo.touched && (cpf.serviceNo.errors?.required)"
                        class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                          aria-hidden="true"></em>
                        lblServiceNumberRequired
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-row" *ngIf="t">
                  <div class="col-lg-6 col-xl-3" *ngFor="let ticket of t.controls; let i = index">
                    <div [formGroup]="ticket">
                      <!-- Service Name -->
                      <div class="af-form-group">
                        <label for="service" translate>lblName<span> in {{Language[i].value}}</span>
                          <strong class="mlt6 required"> * </strong> </label>
                        <div class='lbl-info'>
                          <input formControlName="name" class="form-control mb-2"
                            [(ngModel)]="ServiceInfo.serviceLanguageDetails[i].name" maxlength="60" required>
                        </div>
                      </div>

                      <!--Language Id-->
                      <div class="af-form-group" style="display: none;">
                        <label for="languageId" translate>Language Id</label>
                        <div class='lbl-info'>
                          <input formControlName="languageId" class="form-control mb-2" [ngModel]="Language[i].id"
                            maxlength="30">
                        </div>
                      </div>

                      <!-- Description -->
                      <div class="af-form-group">
                        <label for="service" translate>lblDescription<span> in {{Language[i].value}}</span>
                          <strong class="mlt6 required"> * </strong> </label>
                        <div class='lbl-info'>
                          <textarea rows="4" formControlName="description" class="form-control"
                            [(ngModel)]="ServiceInfo.serviceLanguageDetails[i].description" maxlength="200" required>
                            </textarea>
                          <div *ngIf="cpf.service.touched && (cpf.service.errors?.required)"
                            class="help-block mt-1 text-danger" translate>
                            lblDescriptionIsRequired
                          </div>
                        </div>
                      </div>

                      <!--Internal Description-->
                      <div class="af-form-group">
                        <label for="service" translate>lblInternalDescription<span> in {{Language[i].value}}</span>
                          <strong class="mlt6 required"> * </strong> </label>
                        <div class='lbl-info'>
                          <textarea rows="4" formControlName="internalDescription" class="form-control"
                            [(ngModel)]="ServiceInfo.serviceLanguageDetails[i].internalDescription" Length="1000" required>
                            </textarea>
                          <div *ngIf="cpf.service.touched && (cpf.service.errors?.required)"
                            class="help-block mt-1 text-danger" translate>
                            lblInternalDescriptionIsRequired
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- External Link -->
                  <div class="col-xl-6 af-form-group">
                    <label for="logo" translate>lblServiceExternalLink</label>
                    <div class='lbl-info'>
                      <ng-container>
                        <textarea ngxTrumbowygEditor class="form-control" formControlName="serviceExternalink"></textarea>
                      </ng-container>
                    </div>
                  </div>
                </div>
                <div class="form-row">

                  <!-- Duration -->
                  <div class="col-lg-6 col-xl-2 af-form-group">
                    <label for="service" translate>
                      <span translate>lblDuration</span>
                      <strong class="mlt6 required"> * </strong> </label>
                    <div class='lbl-info'>
                      <input placeholder="hh:mm" formControlName="duration" class="form-control mb-2"
                        [(ngModel)]="ServiceInfo.serviceDetails[0].duration" pattern="^\d{2}:\d{2}$" maxlength="5"
                        required (keypress)="isDigit($event)" (input)="CheckDuration($event)">
                      <div *ngIf="cpf.duration.touched && (cpf.duration.errors?.required)"
                        class="help-block mt-1 text-danger" translate>
                        lblDurationRequired
                      </div>
                      <div *ngIf="cpf.duration.touched && (cpf.duration.errors?.pattern)"
                        class="help-block mt-1 text-danger" translate>
                        lblInvalidDuration
                      </div>
                    </div>
                  </div>

                    
                  <!-- Price -->
                  <div class="col-lg-6 col-xl-2 af-form-group">
                    <label for="service" translate>lblPrice <span class="text-sm1" translate>lblExclVat</span>
                      <strong class="mlt6 required"> * </strong> </label>
                    <div class='lbl-info'>
                      <input formControlName="price" class="form-control mb-2"
                        [ngModel]="ServiceInfo.serviceDetails[0].price|number: '1.2-2'" pattern="^[\d,.\s]+$"
                        maxlength="10" (blur)="onBlur($event)" required>
                      <div *ngIf="cpf.price.touched && (cpf.price.errors?.required)" class="help-block mt-1 text-danger"
                        translate>
                        lblPriceRequired
                      </div>
                      <div *ngIf="cpf.price.touched && (cpf.price.errors?.pattern)" class="help-block mt-1 text-danger"
                        translate>
                        lblOnlyNumbersAreAllowed
                      </div>
                    </div>
                  </div>

                  <!-- PriceInclVAT -->
                  <div class="col-lg-6 col-xl-2 af-form-group">
                    <label for="service" translate>lblPrice <span class="text-sm1" translate>lblInclVAT</span>
                      <strong class="mlt6 required"> * </strong> </label>
                    <div class='lbl-info'>
                      <input formControlName="priceInclVAT" class="form-control mb-2"
                        [ngModel]="ServiceInfo.serviceDetails[0].priceInclVAT|number: '1.2-2'" disabled >

                    </div>
                  </div>

                  <!--Order Number-->
                  <div class="col-lg-6 col-xl-1 af-form-group">
                    <label for="service" translate>lblWidgetSequence
                    </label>
                    <div class='lbl-info'>
                      <input formControlName="widgetSequence" class="form-control mb-2"
                        [(ngModel)]="ServiceInfo.serviceDetails[0].widgetSequence" pattern="^[0-9]*$" maxlength="8"
                        (keypress)="isDigit($event)">
                      <div *ngIf="cpf.price.touched && (cpf.price.errors?.pattern)" class="help-block mt-1 text-danger"
                        translate>
                        lblOnlyNumbersAreAllowed
                      </div>
                    </div>
                  </div>

                  <!--Order Number-->
                  <div class="col-lg-6 col-xl-1 af-form-group">
                    <label for="service" translate>lblPlannerSequence
                    </label>
                    <div class='lbl-info'>
                      <input formControlName="plannerSequence" class="form-control mb-2"
                        [(ngModel)]="ServiceInfo.serviceDetails[0].plannerSequence" pattern="^[0-9]*$" maxlength="8"
                        (keypress)="isDigit($event)">
                      <div *ngIf="cpf.price.touched && (cpf.price.errors?.pattern)" class="help-block mt-1 text-danger"
                        translate>
                        lblOnlyNumbersAreAllowed
                      </div>
                    </div>
                  </div>

                  <!-- Logo -->
                  <div class="col-lg-4 col-xl-3 af-form-group">
                    <label for="logo" translate>lblLogo </label>
                    <div class='lbl-info'>
                      <ng-container>
                        <div class="border mb-3 p-1 d-inline-block">
                          <img af-image [data-code]="ServiceInfo.serviceDetails[0].logo" [data-src]="image" id="UploadImage" alt="Logo does not found."
                            width="50px">
                        </div>
                      </ng-container>
                      <div>
                        <span>
                          <label class="btn btn-outline-primary d-inline-block" for="select-files"
                            translate>lblChangeLogo</label>
                          <input type="file" id="select-files" hidden name="FUImage" accept=".png, .jpg, .jpeg, .svg"
                            (change)="onChangeFileUpload($event.target.files)">
                        </span>
                        <span class="ml-2">
                          <button type="button" class="btn btn-outline-primary d-inline-block" translate
                            (click)="RemoveLogo()">lblRemoveLogo</button>
                        </span>
                      </div>
                      <p class="text-muted">
                        <small translate>lblAllowedJPGPNGSVG</small>
                      </p>
                      <div *ngIf="cpf.Image.touched && (cpf.Image.errors?.required)" class="help-block mt-1 text-danger"
                        translate>lblLogoRequired
                      </div>
                    </div>
                  </div>

                  <!-- Service Category Name -->
                  <div class="col-lg-6 col-xl-3 af-form-group">
                    <label translate>lblCategoryName<strong class="mlt6 required"> * </strong></label>
                    <div class='lbl-info'>
                      <select class="form-control" formControlName="serviceCategoryId"
                        (change)="selectedCategory($event.target.value)">
                        <option disabled translate> lblSelectCategoryName</option>
                        <option *ngFor="let category of categoryList"
                          [selected]="ServiceInfo.serviceDetails[0].serviceCategoryId === category.id"
                          [value]="category.id">
                          {{category.service}}
                        </option>
                      </select>
                    </div>
                  </div>

                  <!-- Competence Name -->
                  <div class="col-lg-6 col-xl-3 af-form-group">
                    <label translate>lblCompetenceName<strong class="mlt6 required"> * </strong></label>
                    <div class='lbl-info'>
                      <select class="form-control" formControlName="competenceId"
                        (change)="selectedCompetence($event.target.value)">
                        <option disabled translate> lblSelectCompetenceName</option>
                        <option *ngFor="let competence of competenceActiveList"
                          [selected]="ServiceInfo.serviceDetails[0].competenceId === competence.id"
                          [value]="competence.id">
                          {{competence.name}}
                        </option>
                      </select>
                    </div>
                  </div>

                  <!-- Special tool -->
                  <div class="col-md-6 col-xl-3 af-form-group" *ngIf="this.showspecialtool">
                    <label for="service" translate>lblSpecialToolTypesvc</label>
                    <div class="lbl-info">
                      <ng-select formControlName="specialToolTypeId"
                        placeholder="{{ 'lblSelectSpecialToolType' | translate }}">
                        <ng-template ng-header-tmp>
                          <span class="mbold" translate>lblSelectSpecialToolTypesvc</span>
                        </ng-template>
                        <ng-option *ngFor="let item of specialToolTypes" [value]="item.id">
                          <span>{{item.name}}</span>
                        </ng-option>
                      </ng-select>
                    </div>
                  </div>
                  <div class=" col-lg-6 col-xl-3 af-form-group">
                    <label for="template-make" translate>lblChargingGroup</label>
                    <div class='lbl-info'>
                      <ng-select formControlName="chargingGroup" placeholder="{{ 'lblSelectChargingGroup' | translate }}" required
                        [(ngModel)]="chargingGroup">
                        <ng-template ng-header-tmp>
                          <span class="mbold w-66px" translate>lblCode</span>
                          <span class="mbold" translate>lblName</span>
                        </ng-template>
                  
                        <ng-option *ngFor="let type of chargingGroupList" [value]="type.groupNo">
                          <span class="w-66px">{{type.groupNo}}</span>
                          <span class="mx-2 hide-ng-dropdown-panel">-</span>
                          <span>{{type.charginGroupName}}</span>
                        </ng-option>
                      </ng-select>
                    </div>
                  </div>
                  <!-- DmsServiceId  -->
                  <div class="col-lg-3 col-xl-3 af-form-group" *ngIf="this.dmsServiceId">
                    <label for="service" translate>lblDmsServiceId</label>
                    <div class='lbl-info'>
                      <input formControlName="dmsServiceId" class="form-control mb-2">
                    </div>
                  </div>

                  <div class="col-lg-6 col-xl-6 af-form-group">
                    <div class="border p-3">
                      <label for="thisservice" translate>lblOptionalService</label>
                      <div class='lbl-info'>

                        <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="allServices"
                          (ngModelChange)="onChildServiceSelected($event)" [(ngModel)]="selectedChildServices"
                          [ngModelOptions]="{standalone: true}">
                        </ng-multiselect-dropdown>

                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-xl-6 af-form-group">
                    <div class="border p-3">
                      <span for="thisservice" translate>lblAfxPackage  </span> (<span class="lbl-info" style="color: red;" translate>lblPackageWithoutServices</span>)
                      <div class='lbl-info'>
                        <ng-select formControlName="packageNo" placeholder="{{ 'lblSelectPackage' | translate }}"
                          [(ngModel)]="selectPackage">
                          <ng-template ng-header-tmp>
                            <span class="mbold w-66px" translate>lblMakeCode</span>
                            <span class="mbold w-66px" translate>lblPackageNumber</span>
                            <span class="mbold" translate>lblVersionNumber</span>
                          </ng-template>

                          <ng-option *ngFor="let item of packageDropdownList" [value]="item.selectPackage">
                            <span class="w-66px">{{item.makeCode}}</span>
                            <span class="mx-2 hide-ng-dropdown-panel">-</span>
                            <span class="w-66px">{{item.packageNo}}</span>
                            <span class="mx-2 hide-ng-dropdown-panel">-</span>
                            <span>{{item.packageVersionNo}}</span>
                          </ng-option>
                        </ng-select>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 pt-3">
                    <div class="row">
                      <!-- Is Active -->
                      <div class="col-auto">
                        <div class="custom-control custom-switch">
                          <input type="checkbox" class="custom-control-input" id="isActive"
                            [checked]="ServiceInfo.serviceDetails[0].isActive"
                            (change)="onChangeIsActive(ServiceInfo.serviceDetails[0].isActive)">
                          <label class="custom-control-label" for="isActive">
                            <span translate>lblActive</span>
                          </label>
                        </div>
                      </div>
                       <!-- Is Display in Widget -->
                       <div class="col-auto">
                        <div class="custom-control custom-switch">
                          <input type="checkbox" class="custom-control-input" id="displayInWidget"
                            [checked]="ServiceInfo.serviceDetails[0].displayInWidget"
                            (change)="onChangedisplayInWidget(ServiceInfo.serviceDetails[0].displayInWidget)">
                          <label class="custom-control-label" for="displayInWidget">
                            <span translate>lblDisplayInWidget</span>
                          </label>
                        </div>
                      </div>
                      <!-- Is Display Price In Widget -->
                      <div class="col-auto">
                        <div class="custom-control custom-switch">
                          <input type="checkbox" class="custom-control-input" id="displayPriceInWidget"
                            [disabled] = "!ServiceInfo.serviceDetails[0].displayInWidget"
                            [checked]="ServiceInfo.serviceDetails[0].displayPriceInWidget"
                            (change)="onChangedisplayPriceInWidget(ServiceInfo.serviceDetails[0].displayPriceInWidget)">
                          <label class="custom-control-label" for="displayPriceInWidget">
                            <span translate>lblDisplayPriceInWidget</span>
                          </label>
                        </div>
                      </div>
                      <!-- Is Fixed -->
                      <div class="col-auto">
                        <div class="custom-control custom-switch">
                          <input type="checkbox" class="custom-control-input" id="isFixed"
                            [checked]="ServiceInfo.serviceDetails[0].isFixed"
                            (change)="onChangeIsFixed(ServiceInfo.serviceDetails[0].isFixed)">
                          <label class="custom-control-label" for="isFixed">
                            <span translate>lblIsFixed</span>
                          </label>
                        </div>
                      </div>
                      <div class="col-auto">
                        <div class="custom-control custom-switch">
                          <input type="checkbox" class="custom-control-input" id="needAttention"
                            [checked]="ServiceInfo.serviceDetails[0].needAttention"
                            (change)="onChangeNeedAttention(ServiceInfo.serviceDetails[0].needAttention)">
                          <label class="custom-control-label" for="needAttention">
                            <span translate>lblNeedAttention</span>
                          </label>
                        </div>
                      </div>
                      <div class="col-auto">
                        <div class="custom-control custom-switch">
                          <input type="checkbox" class="custom-control-input" id="recommendedService"
                            [checked]="ServiceInfo.serviceDetails[0].recommendedService"
                            (change)="onChangeRecommendedService(ServiceInfo.serviceDetails[0].recommendedService)">
                          <label class="custom-control-label" for="recommendedService">
                            <span translate>lblRecommendedService</span>
                          </label>
                        </div>
                      </div>
                      <div *ngIf="isWarningLightFeature">
                        <div class="col-auto">
                          <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" id="isWarningLight"
                              [checked]="ServiceInfo.serviceDetails[0].isWarningLight"
                              (change)="onChangeIsWarningLight(ServiceInfo.serviceDetails[0].isWarningLight)">
                            <label class="custom-control-label" for="isWarningLight">
                              <span translate>lblWarningLight</span>
                            </label>
                          </div>
                        </div>

                        <div class="col-auto-form-group"
                          *ngIf="ServiceInfo.serviceDetails[0].isWarningLight">
                          <label for="warningLight" translate>lblWarningLightName<strong class="mlt6 required"> *
                            </strong></label>
                          <div class='lbl-info'>

                            <ng-multiselect-dropdown [settings]="dropdownSettingsWarningLight" [data]="allWarningLight"
                              (ngModelChange)="onWarningLightSelected($event)" [(ngModel)]="selectedWarningLight"
                              [ngModelOptions]="{standalone: true}">
                            </ng-multiselect-dropdown>

                          </div>
                        </div>
                      </div>

                    </div>
                  </div>


                  <div class="form-row">
                    <div class="col-auto">
                      <div class="col af-form-group mt-4 mb-0">
                        <div class="form-check mt-2">
                          <input class="form-check-input"
                            [(ngModel)]="editServiceForm.value.isAdditionalCustomerComment"
                            formControlName="isAdditionalCustomerComment" type="checkbox" value=""
                            id="isCustomerComment">
                          <label class="form-check-label" for="isCustomerComment" translate>
                            lblAdditionalCustomerComment
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">

                    <div class="form-row mt-4" *ngIf="editServiceForm.value.isAdditionalCustomerComment && c">
                      <div class="col-lg-6 col-xl-3 af-form-group" *ngFor="let ticket of c.controls; let i = index">
                        <div [formGroup]="ticket">
                          <div class="af-form-group">
                            <label for="name"><span translate>lblAdditionalCustomerCommentTextBoxLabel</span><span> in
                                {{Language[i].value}}</span>
                              <strong class="mlt6 required"> * </strong> </label>
                            <div class="lbl-info">
                              <input formControlName="name" class="form-control mb-2" maxlength="100"
                                [(ngModel)]="ServiceInfo.customerCommentLanguageDetails[i].name">
                            </div>
                          </div>
                          <div class="af-form-group" style="display: none;">
                            <label for="languageId" translate>Language Id</label>
                            <div class="lbl-info">
                              <input formControlName="languageId" class="form-control mb-2" [ngModel]="Language[i].id"
                                maxlength="30">
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>



                  <div class="col-12">


                    <div class="mt-4 ctm-tab custom-card card-accord">
                      <ngb-accordion #a="ngbAccordion" activeIds="!ngb-panel-0" class="overflow-none-card">
                        <ngb-panel title="first">
                          <ng-template ngbPanelHeader class="custom-header ctm">
                            <div class="d-flex align-items-center">
                              <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center text-left"
                                aria-label="Center Align" translate>
                                lblDurationAndPriceForServiceBooking
                                <ng-container *ngIf="!a.activeIds.includes('first')"><em
                                    class="fas fa-angle-down fa-lg ml-auto"></em>
                                </ng-container>
                                <ng-container *ngIf="a.activeIds.includes('first')"><em
                                    class="fas fa-angle-up fa-lg ml-auto"></em>
                                </ng-container>
                              </button>
                            </div>
                          </ng-template>
                          <ng-template ngbPanelContent>
                                <div class="table-responsive editservicetblresponsive">
                                  <div *ngFor="let serviceFilter of ServiceFilterForm; let in=index;let last=last">
                                    <app-service-duration-price [in]=in [service]="serviceDetails"
                                    [serviceFilter]="serviceFilter" [isAddView]="isAddView"
                                    (addServiceTimeDetailSlotOpt)="AddServiceFilter($event)"
                                    (removeServiceTimeDetailSlotOpt)="RemoveServiceFilter($event)"
                                    ></app-service-duration-price>
                                                     </div>
                            </div>

                          </ng-template>
                        </ngb-panel>

                      </ngb-accordion>
                    </div>
                    <div class="mt-4 ctm-tab custom-card card-accord">
                      <ngb-accordion #a="ngbAccordion" activeIds="!ngb-panel-1" class="overflow-none-card">
                        <ngb-panel title="second">
                          <ng-template ngbPanelHeader class="custom-header ctm">
                            <div class="d-flex align-items-center">
                              <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center text-left"
                                aria-label="Center Align" translate>
                                lblDiagnoseChecklist
                                <ng-container *ngIf="!a.activeIds.includes('second')"><em
                                    class="fas fa-angle-down fa-lg ml-auto"></em>
                                </ng-container>
                                <ng-container *ngIf="a.activeIds.includes('second')"><em
                                    class="fas fa-angle-up fa-lg ml-auto"></em>
                                </ng-container>
                              </button>
                            </div>
                          </ng-template>
                          <ng-template ngbPanelContent>
                            <div *ngIf="selectedChecklists && selectedChecklists.length > 0" class="">
                              <ul class="mb-3">
                                <li *ngFor="let item of selectedChecklists;let i = index"
                                  (click)="removeChecklist(i,item)" class="btn btn-outline-dark p-2 mr-2 mb-2">
                                  {{ item.subCheckListTitle }}
                                  <a class="ml-2 p-1">
                                    <span class="fa fa-times"></span></a>
                                </li>
                              </ul>
                            </div>
                            <div class="row">
                              <div class="col-lg-2 col-md-3 col-sm-6 pl-4">
                                <ng-select placeholder="{{ 'lblSelectChecklist' | translate }}"
                                  [(ngModel)]="checkListSelected" [ngModelOptions]="{standalone: true}">
                                  <ng-option *ngFor="let checklist of checkList" [value]="checklist.id">
                                    {{checklist.subCheckListTitle}}
                                  </ng-option>
                                </ng-select>
                              </div>
                              <div class="col-3 af-form-group mb-1">
                                <div class="lbl-info">
                                  <button type="button" aria-label="Center Align" class="btn btn-primary ml-2"
                                    style="height:28px" ngbTooltip="{{ 'lblAddCheckList' | translate }}" translate
                                    (click)="addChecklist()">
                                    <em class="fas fa-plus font15"></em></button>
                                </div>
                              </div>
                            </div>


                          </ng-template>
                        </ngb-panel>

                      </ngb-accordion>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-3 bg-light pp-footer-top-brdr">
          <div class="row">
            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
              <button type="submit" class="btn btn-primary btn-lg mr-sm-2" aria-label="Center Align" 
                [disabled]="!editServiceForm.valid" translate><em
                  class="far fa-times-circle font16 align-top mr-2"></em>lblSaveChanges</button>
              <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate><em
                  class="fa fa-arrow-circle-left font16 align-top mr-2"></em>lblBack</a>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>